import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import cssModule from 'react-css-modules';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';

import { getMatchSportId, getReadyMatchId } from 'reducers/index';
import useOnScrollVertical from 'newDesign/modules/common/hooks/OnScrollVertical';
import Table from 'newDesign/modules/preMatch/components/statSlides/leagueTable/components/table/Table';
import { SEC } from 'constants/app';
import { sport } from 'constants/enum';

import styles from 'newDesign/modules/preMatch/components/statSlides/leagueTable/components/leagueTable/LeagueTable.scss';

const mapStateToProps = state => ({
  matchId: getReadyMatchId(state),
  sportId: getMatchSportId(state, getReadyMatchId(state)),
});

const LeagueTable = ({ matchId, sportId }) => {
  const intl = useIntl();

  const scrollEndRef = useRef(null);
  const scrollPosition = useOnScrollVertical(scrollEndRef, 1, 4 * SEC);

  const columns = React.useMemo(
    () => [
      {
        Header: '',
        accessor: 'changeTotal', // accessor is the "key" in the data
      },
      {
        Header: intl.formatMessage({ id: 't_statistics_pos' }),
        accessor: 'pos',
      },
      {
        Header: intl.formatMessage({ id: 't_statistics_team' }),
        accessor: 'name',
      },
      {
        Header: intl.formatMessage({ id: 't_statistics_pld' }),
        accessor: 'pld',
      },
      {
        Header: intl.formatMessage({ id: 't_statistics_w' }),
        accessor: 'wins',
      },
      {
        Header: intl.formatMessage({ id: 't_statistics_d' }),
        accessor: 'draws',
      },
      {
        Header: intl.formatMessage({ id: 't_statistics_l' }),
        accessor: 'losses',
      },
      {
        Header: intl.formatMessage({ id: 't_statistics_gf_ga' }),
        accessor: 'gfga',
      },
      {
        Header: intl.formatMessage({ id: 't_statistics_pts' }),
        accessor: 'pts',
      },
    ],
    [intl],
  );

  const isTennisMatch = [sport.tennis, sport.table_tennis].includes(sportId);
  const filteredColumns = React.useMemo(
    () => (isTennisMatch
      ? columns.filter(column => !['draws', 'gfga', 'pts'].includes(column.accessor))
      : columns),
    [columns, isTennisMatch],
  );

  const gridTemplateColumns = isTennisMatch
    ? '0.3fr 0.3fr 3fr 0.3fr 0.3fr 0.3fr'
    : '0.3fr 0.3fr 3fr 0.3fr 0.3fr 0.3fr 0.3fr 0.3fr 0.3fr';
  const classNameTable = 'z-10 fs-18 font-second';

  return (
    <React.Fragment>
      <div styleName='prematch__header' className={classNameTable}>
        <div styleName='grid' className='grid' style={{ gridTemplateColumns }}>
          <Table matchId={matchId} columns={filteredColumns} />
        </div>
      </div>
      <div styleName='prematch__table' className={classNameTable}>
        <div styleName='grid' className='grid' style={{ gridTemplateColumns, top: -scrollPosition + 'px' }}>
          <Table matchId={matchId} columns={filteredColumns} />
          <div ref={scrollEndRef} data-testid='scroll-end-ref' />
        </div>
      </div>
    </React.Fragment>
  );
};

LeagueTable.propTypes = {
  matchId: PropTypes.number.isRequired,
  sportId: PropTypes.number,
};

LeagueTable.defaultProps = {
  sportId: null,
};

const LeagueTableStyled = cssModule(LeagueTable, styles);
export default connect(mapStateToProps)(LeagueTableStyled);
